import React from 'react';
import { Shield, Users, Clock, Award } from 'lucide-react';
import { companyInfo } from '../data/api';

const AboutSection = () => {
  const stats = [
    { icon: Clock, value: '7/24', label: 'Kesintisiz Hizmet' },
    { icon: Users, value: '1000+', label: 'Mutlu Müşteri' },
    { icon: Shield, value: '100%', label: 'Güvenli Yolculuk' },
    { icon: Award, value: '10+', label: 'Yıllık Deneyim' }
  ];

  return (
    <section id="about" className="py-20 md:py-28 bg-zinc-950 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(ellipse_at_top_left,_var(--tw-gradient-stops))] from-amber-900/10 via-zinc-950 to-zinc-950"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left - Content */}
          <div>
            <span className="inline-block text-amber-400 text-sm font-semibold tracking-wider uppercase mb-4">
              Hakkımızda
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6">
              Denizli'nin Güvenilir <span className="text-amber-400">Taksi Hizmeti</span>
            </h2>
            <div className="space-y-4 text-zinc-400 text-lg leading-relaxed">
              <p>
                <span className="text-amber-400 font-semibold">{companyInfo.name}</span>, Denizli ve çevresinde 
                yıllardır güvenilir taksi hizmeti sunmaktadır. Müşteri memnuniyetini ön planda tutarak, 
                temiz ve bakımlı araçlarımızla kaliteli hizmet veriyoruz.
              </p>
              <p>
                Şehir içi ulaşımdan <span className="text-white">Denizli Çardak Havalimanı transferine</span>, 
                <span className="text-white"> Pamukkale turlarından</span> şehirlerarası yolculuklara kadar 
                her türlü taksi ihtiyacınız için <span className="text-amber-400">7/24</span> hizmetinizdeyiz.
              </p>
              <p>
                <span className="text-white">Hastane transferleri</span> konusunda özellikle hassas davranıyor, 
                hastalarımızı özenle taşıyoruz. Plakamız: <span className="text-amber-400 font-semibold">{companyInfo.plate}</span>
              </p>
            </div>

            {/* Trust Points */}
            <div className="mt-8 grid grid-cols-2 gap-4">
              {[
                'Lisanslı ve sigortalı',
                'Deneyimli sürücü',
                'Temiz araçlar',
                'Uygun fiyatlar'
              ].map((point, index) => (
                <div key={index} className="flex items-center gap-2 text-zinc-300">
                  <div className="w-2 h-2 bg-amber-500 rounded-full"></div>
                  <span>{point}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right - Stats */}
          <div className="grid grid-cols-2 gap-6">
            {stats.map((stat, index) => (
              <div
                key={index}
                className="bg-zinc-900/50 backdrop-blur-sm rounded-2xl p-6 border border-zinc-800 hover:border-amber-500/30 transition-all duration-300 hover:shadow-xl hover:shadow-amber-500/5 text-center"
              >
                <div className="w-14 h-14 mx-auto mb-4 bg-gradient-to-br from-amber-400 to-amber-600 rounded-xl flex items-center justify-center shadow-lg shadow-amber-500/30">
                  <stat.icon className="w-7 h-7 text-zinc-900" />
                </div>
                <p className="text-3xl md:text-4xl font-bold text-amber-400 mb-2">{stat.value}</p>
                <p className="text-zinc-400 text-sm">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
